"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Response = exports.Status = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const user_1 = require("../../../../user");
exports.NAMESPACE = 'Culligan.Api.V1.Admin.User.ExistenceCheck';
exports.Status = {
    ExistsWithinAnotherTenant: 'EXISTS_WITHIN_ANOTHER_TENANT',
    ExistsWithinYourTenant: 'EXISTS_WITHIN_YOUR_TENANT',
    DoesNotExist: 'DOES_NOT_EXIST',
};
exports.Response = effect_1.Schema.Union(effect_1.Schema.Struct({
    status: effect_1.Schema.Literal(exports.Status.ExistsWithinAnotherTenant),
    tenantName: effect_1.Schema.NullOr(effect_1.Schema.String),
}), effect_1.Schema.Struct({
    status: effect_1.Schema.Literal(exports.Status.ExistsWithinYourTenant),
    userId: user_1.Id,
    tenantName: effect_1.Schema.String,
}), effect_1.Schema.Struct({
    status: effect_1.Schema.Literal(exports.Status.DoesNotExist),
})).annotations({
    identifier: `${exports.NAMESPACE}.Response`,
});
//# sourceMappingURL=existence-check.js.map